import format from 'date-fns/format'
import parseIso from 'date-fns/parseISO'
import { fr, enGB } from 'date-fns/locale'

/**
 * Display date in the user locale format
 * @param date The date in ISOString format
 */
const formatDate = (date: string): string => {
  // undefined is the default locale : en-US
  const localeDate = currentLocale === 'fr' ? fr : currentLocale === 'en' ? enGB : fr

  return format(parseIso(date), 'P', { locale: localeDate })
}

const formatDateTimeStampWithlocale = (
  timestamp: number,
  locale: string,
  formatDisplay = 'P'
): string => {
  // undefined is the default locale : en-US
  const localeDate = locale === 'fr' ? fr : locale === 'en' ? enGB : fr

  return format(new Date(timestamp * 1000), formatDisplay, { locale: localeDate })
}

const formatDateTimeStamp = (timestamp: number | null, formatDisplay = 'P'): string => {
  return timestamp ? formatDateTimeStampWithlocale(timestamp, currentLocale, formatDisplay) : ''
}

export { formatDate, formatDateTimeStamp, formatDateTimeStampWithlocale }
